const updateAddDocumentCompanies = {
  toastr: 'Documento atualizado',
  toastr1: 'O documento foi atualizado com sucesso'
};

export default updateAddDocumentCompanies;
